export default __webpack_public_path__ + "static/media/6.61020b5f.jpg";